import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Checkbox, Grid, Tooltip, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

type Props = {
  disabled?: boolean;
  employerName?: string;
  employerBusinessId?: string;
  showEmployerInfoIcon?: boolean;
};

export const EezyWorkControl = ({
  disabled,
  employerName,
  employerBusinessId,
  showEmployerInfoIcon = false,
}: Props) => {
  const { t } = useTranslation();

  const { control, setValue, clearErrors } = useFormContext();
  const isEmployerDetailsMissing = !employerName && !employerBusinessId;

  return (
    <>
      <Grid item container xs={3} />
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="isEezyWork"
          control={control}
          render={({ field: { value, onChange } }) => (
            <>
              <Checkbox
                checked={value}
                disabled={disabled}
                onChange={(e) => {
                  const checked = e.target.checked;
                  onChange(checked);

                  if (checked) {
                    setValue("workLocationName", "");
                  } else {
                    setValue("workLocation", null);
                    setValue("dayCount", null);
                  }
                  setValue("city", "");
                  clearErrors(["workLocation", "city", "dayCount"]);
                }}
                sx={{
                  "&.MuiCheckbox-root": {
                    paddingLeft: "0px",
                  },
                }}
              />
              <Typography variant={disabled ? "secondary" : "inherit"}>
                {t("workHistory:eezyWork")}
              </Typography>
              {showEmployerInfoIcon && value && (
                <Tooltip
                  title={
                    isEmployerDetailsMissing ? (
                      t("workHistory:missingEmployerDetailsTooltip")
                    ) : (
                      <Typography component="div">
                        <Typography component="div" fontWeight={700}>
                          {t("workHistory:employerName")}:
                        </Typography>
                        <Typography component="div">{employerName || ""}</Typography>
                        <Typography component="div" sx={{ mt: 1 }} fontWeight={700}>
                          {t("workHistory:employerBusinessId")}:
                        </Typography>
                        <Typography component="div">
                          {employerBusinessId || ""}
                        </Typography>
                      </Typography>
                    )
                  }
                  placement="right"
                  arrow
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    sx={{
                      ml: 1,
                      color: isEmployerDetailsMissing
                        ? "warning.main"
                        : "text.secondary",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              )}
            </>
          )}
        />
      </Grid>
    </>
  );
};
